export default {
  components : {
    contact_form : {
      honeypot_error : "Please don't use automatic submission tools."
    }
  },
  contactForm : {
    name : "Name",
    phone : "Phone",
    email : "Email",
    message : "Message:",
    date : 'Date',
    persons : 'Number of persons',
    send : 'Send',
    error : 'Error',
    sending : 'Sending',
    sent : 'Sent',
    toastr : {
      error : 'Error sending message',
      nameRequired : 'Please enter your name',
      emailRequired : 'Please enter your email address',
      recaptchaFailed : 'Error! Please try again.'
    }
  }
}
